export default {"src":"/_next/static/media/full-facilities.ac79539d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};